import { get, isNull } from 'lodash-es';

export function getOptionPrice(option) {
  const discountedMSRP = get(option, 'discountedMSRP', 0);
  return !isNull(discountedMSRP) ? discountedMSRP : get(option, 'baseMSRP', 0);
}
